// src/components/hero/RiskBadge.jsx — v8.4 FINAL
const riskConfig = {
  low:      { color: "var(--risk-low)",     label: "LOW RISK" },
  medium:   { color: "var(--risk-medium)",  label: "MEDIUM RISK" },
  high:     { color: "var(--risk-high)",    label: "HIGH RISK" },
  critical: { color: "var(--risk-critical)",label: "CRITICAL" },
  unknown:  { color: "var(--risk-unknown)", label: "UNKNOWN" },
};

export default function RiskBadge({ status, score, engineOnline }) {
  const cfg = engineOnline
    ? (riskConfig[status] ?? riskConfig.unknown)
    : { color: "var(--risk-unknown)", label: "ENGINE OFFLINE" };

  return (
    <div style={{
      display:      "flex",
      alignItems:   "center",
      gap:          10,
      padding:      "8px 14px",
      borderRadius: "var(--radius)",
      background:   `${cfg.color}12`,
      border:       `1px solid ${cfg.color}30`,
    }}>
      <span style={{
        width:        8,
        height:       8,
        borderRadius: "50%",
        background:   cfg.color,
        boxShadow:    `0 0 8px ${cfg.color}`,
        flexShrink:   0,
      }} />
      <span style={{
        fontFamily:    "var(--font-mono)",
        fontSize:      11,
        fontWeight:    700,
        letterSpacing: "0.12em",
        color:         cfg.color,
      }}>
        {cfg.label}
      </span>
      {score != null && engineOnline && (
        <span style={{
          fontFamily: "var(--font-mono)",
          fontSize:   10,
          color:      "var(--text-muted)",
          marginLeft: 4,
        }}>
          {typeof score === "number" ? score.toFixed(2) : score}
        </span>
      )}
    </div>
  );
}
